//#region src/rooms/roomNames.ts
var e = 200, t = 2, n = 120, r = (e, t, n) => {
	let r = Number.isFinite(n) ? Math.min(Math.max(Math.trunc(n), 0), 200) : 0, i = e.trim();
	return Array.from({ length: r }, (e, n) => {
		let r = Math.trunc(t) + n;
		return i ? `${i} ${r}` : String(r);
	});
}, i = (e) => {
	let t = /* @__PURE__ */ new Set();
	for (let [n, r] of e.entries()) {
		let e = r.trim();
		if (e.length === 0) return {
			index: n,
			issue: "empty"
		};
		if (e.length > 120) return {
			index: n,
			issue: "tooLong"
		};
		let i = e.toLowerCase();
		if (t.has(i)) return {
			index: n,
			issue: "duplicate"
		};
		t.add(i);
	}
	return null;
};
//#endregion
export { e as MAX_POOL_ROOMS, n as MAX_ROOM_NAME_LENGTH, t as MIN_POOL_ROOMS, r as buildRoomNames, i as findRoomNameIssue };
